<template>
  <div>
    <div v-if="desktop">
      <MovieReminder
        v-if="selected && selected.due"
        :key="selectedMovieKey"
        :start="configuration.now"
        :dictionary="dictionary"
        :configuration="configuration"
        :due="selected.due"
        :movie-id="selectedMovieKey" />
    </div>
    <ModalOverlay v-model="showReminderModal">
      <template #header>
        <i class="icon-camera"></i>
        <div class="b-pop-up__header__title">{{ dictionary.notify }}</div>
      </template>
      <template #body>
        <div class="b-pop-up__content">
          <MovieReminder
            v-if="selected && selected.due"
            :key="selectedMovieKey"
            :start="configuration.now"
            :dictionary="dictionary"
            :configuration="configuration"
            :due="selected.due"
            :movie-id="selectedMovieKey"
            :mobile-ui-config="{
              mainClass: '',
              showTitle: false,
              showMobileTitle: true,
            }"
            :selected-movie="selected" />
        </div>
      </template>
    </ModalOverlay>
  </div>
</template>

<script setup>
import { computed, onMounted , ref, watch } from 'vue'
import { getData } from '../../lib/lib'
import MovieReminder from '../components/MovieReminder.vue'
import ModalOverlay from '../components/ModalOverlay.vue'
import useViewport from '../../features/viewport.js'
const { desktop } = useViewport()
const {
  records: slides,
  notifyDictionary,
  configuration: config,
} = getData('comingSoonStripData')

const records = ref([])
const cpage = ref(0)
const dictionary = ref({})
const configuration = ref({})
const showReminderModal = ref(false)

watch(desktop, () => {
  if (desktop.value) {
    showReminderModal.value = false
  }
})

const selected = computed(() => {
  return records.value[cpage.value]
})
const selectedMovieKey = computed(() => {
  return selected.value.movieId
})
onMounted(() => {
  if (slides && slides.length) {
    records.value = [...slides]
  }
  dictionary.value = notifyDictionary
  configuration.value = config

  jQuery(document).on('movie-reminder-clicked', () => {
    showReminderModal.value = true
  })
})
</script>
